export default class Specifics {
    constructor(_id, name) {
        this._id = _id;
        this.name = name;
      }
    
      static fromJson(json) {
        return new Specifics(json._id, json.name);
      }
}